export const decimalsScale = (decimals: number) => `1${Array(decimals).fill('0').join('')}`
